<script setup>
import { useDynamicModalStore } from '@/Stores/DynamicModal'
import { DialogDescription } from '@headlessui/vue'
import Button from '@/Components/FormElements/Button.vue'
import ModalPanel from '@/Components/Generic/Modals/ModalPanel.vue'
import ModalTitle from '@/Components/Generic/Modals/ModalTitle.vue'


const props = defineProps({
    title: {
        type: String,
        default: 'Confirm Action'
    },
    message: {
        type: String,
        default: 'Are you sure you want to perform this action?'
    },
    onCancel: {
        type: Function,
        default: () => {}
    },
    onConfirm: {
        type: Function,
        default: () => {}
    },
    confirmText: {
        type: String,
        default: 'OK'
    },
    cancelText: {
        type: String,
        default: 'Cancel'
    },
    confirmColor: {
        type: String,
        default: 'blue'
    },
    cancelColor: {
        type: String,
        default: 'transparent'
    },
    showCancel: {
        type: Boolean,
        default: true
    }
})

const store = useDynamicModalStore()

function onCancel() {
    props.onCancel()
    store.close()
}

function onConfirm() {
    props.onConfirm()
    store.close()
}
</script>

<template>
    <ModalPanel @close="onCancel">
        <div class="space-y-6">
            <div class="space-y-4">
                <ModalTitle>
                    {{ props.title }}
                </ModalTitle>

                <DialogDescription class="text-slate-600 dark:text-slate-300" v-html="props.message" />
            </div>

            <div class="flex justify-end items-center space-x-2">
                <Button v-if="props.showCancel" type="button" :color="cancelColor" @click="onCancel">{{ cancelText }}</Button>
                <Button :color="confirmColor" @click="onConfirm">{{ confirmText }}</Button>
            </div>
        </div>
    </ModalPanel>
</template>
